export default __webpack_public_path__ + "images/banner-offer.png";